import CtaQuery from '~/graphql/queries/Cta.graphql';
import type { CtaEntryFragment } from '~/types/craft-schema';

type CtaPageType = 'artist' | 'eventContent' | 'festival' | 'productionHouse' | 'venue';

export const filterCtas = (ctas: CtaEntryFragment[], pageType: CtaPageType) =>
    ctas.filter(cta => cta.ctaPageTypes?.includes(pageType));

export const useCta = () => {
    const ctas = ref<CtaEntryFragment[]>([]);

    useAsyncQuery<{ entries: CtaEntryFragment[] }>({
        query: CtaQuery,
    }).then(({ data }) => {
        ctas.value = data.value?.entries ?? [];
    });

    return ctas;
};